import React, { useState } from 'react';
import Swal from 'sweetalert2';
import Axios from 'axios';
import config from '../Componentes/config';

const ModalComprobantePago = ({ isOpen, onClose, ordenData, onSuccess }) => {
    const [numeroComprobante, setNumeroComprobante] = useState('');
    const [archivoComprobante, setArchivoComprobante] = useState(null);
    const [cargando, setCargando] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!numeroComprobante.trim()) {
            Swal.fire('Error', 'Debe ingresar el número de comprobante de pago', 'error');
            return;
        }

        if (!archivoComprobante) {
            Swal.fire('Error', 'Debe seleccionar un archivo de comprobante de pago', 'error');
            return;
        }

        setCargando(true);

        try {
            const formData = new FormData();
            formData.append('comprobantePago', archivoComprobante);
            formData.append('idOrden', ordenData.ID_Orden);
            formData.append('numeroComprobantePago', numeroComprobante);
            formData.append('usuario', ordenData.usuario || 'admin'); // Aquí deberías pasar el usuario actual
            formData.append('fechaPago', new Date().toISOString().slice(0, 19).replace('T', ' '));

            const response = await Axios.post(`${config.API_URL}/completarOrdenConComprobantePago`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                Swal.fire({
                    icon: 'success',
                    title: '¡Pago Registrado!',
                    text: 'La orden ha sido marcada como pagada exitosamente',
                    timer: 2000,
                    showConfirmButton: false
                });

                onSuccess(); // Callback para actualizar la lista de órdenes
                onClose(); // Cerrar el modal
            }
        } catch (error) {
            console.error('Error al completar orden con comprobante de pago:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un error al registrar el comprobante de pago'
            });
        } finally {
            setCargando(false);
        }
    };

    const resetForm = () => {
        setNumeroComprobante('');
        setArchivoComprobante(null);
    };

    const handleClose = () => {
        resetForm();
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            Registrar Pago - Orden de Compra N° {ordenData?.Numero_Orden}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                            disabled={cargando}
                        ></button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 mb-3">
                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle me-2"></i>
                                        Para registrar el pago de esta orden, debe ingresar el número de comprobante de pago y subir el archivo correspondiente.
                                    </div>
                                </div>

                                <div className="col-12 mb-3">
                                    <label htmlFor="numeroComprobante" className="form-label">
                                        <i className="fas fa-hashtag me-2"></i>
                                        Número de Comprobante de Pago *
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="numeroComprobante"
                                        value={numeroComprobante}
                                        onChange={(e) => setNumeroComprobante(e.target.value)}
                                        placeholder="Ingrese el número de comprobante de pago"
                                        disabled={cargando}
                                        required
                                    />
                                </div>

                                <div className="col-12 mb-3">
                                    <label htmlFor="archivoComprobante" className="form-label">
                                        <i className="fas fa-file-upload me-2"></i>
                                        Archivo de Comprobante de Pago *
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="archivoComprobante"
                                        onChange={(e) => setArchivoComprobante(e.target.files[0])}
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        disabled={cargando}
                                        required
                                    />
                                    <div className="form-text">
                                        Formatos permitidos: PDF, DOC, DOCX, JPG, PNG (máx. 10MB)
                                    </div>
                                </div>

                                {archivoComprobante && (
                                    <div className="col-12 mb-3">
                                        <div className="alert alert-success">
                                            <i className="fas fa-file me-2"></i>
                                            Archivo seleccionado: <strong>{archivoComprobante.name}</strong>
                                            <br />
                                            <small>Tamaño: {(archivoComprobante.size / 1024 / 1024).toFixed(2)} MB</small>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleClose}
                                disabled={cargando}
                            >
                                <i className="fas fa-times me-2"></i>
                                Cancelar
                            </button>
                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={cargando}
                            >
                                {cargando ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                        Procesando...
                                    </>
                                ) : (
                                    <>
                                        <i className="fas fa-check me-2"></i>
                                        Registrar Pago
                                    </>
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ModalComprobantePago;